import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "human.icon",
  "use": "human.icon-usage",
  "viewBox": "135.567 -11586.593 20.866 23.185",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"135.567 -11586.593 20.866 23.185\" id=\"human.icon\"><path d=\"M13.433,2a2.318,2.318,0,1,1-2.318,2.318A2.325,2.325,0,0,1,13.433,2Zm10.433,8.115H16.911v15.07H14.592V18.229H12.274v6.955H9.955V10.115H3V7.8H23.866Z\" transform=\"translate(132.567 -11588.593)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/human.icon.svg
// module id = SlQ1
// module chunks = 13